import React from 'react';
import AboutIntro from './aboutComponents/aboutIntro';
import Credentials from './aboutComponents/credentials';
import usePageTitle from '../usePageTitle';

export default function About() {
    usePageTitle({
        title: 'TaxObey | About Us',
        description: 'Learn about TaxObey, our tax advisory background, and the professional credentials behind our compliance and accounting services.',
        path: '/about',
    });

    return (
        <div className="about-us">
            <AboutIntro />
            <Credentials />
        </div>
    );
}